import { useEffect, useState } from 'react';

const OrganonOrderingCartOrderConfirmation = () => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [myOrderData, setMyOrderData] = useState([]);
  const [viewOrderMaterialsDetails, setViewOrderMaterialsDetails] = useState(null)
  const [modalInstance, setModalInstance] = useState(null);

  const [errorsStatusUI, setErrorsStatusUI] = useState({
    orderEmpty: false,
    badRequest: false,
    criticalErrorAPIend: false,
  });

  /**
   * Fetch order data when the component mounts.
   * This function retrieves the user's order data from the API.
   * It sets the state for myOrderData and handles various error states.
   */
  useEffect(() => {
    fetch(`${window.front_end_ajax_obj.siteurl}myorders/v1/myorderdata`, {
      method: "GET",
      headers: {
        'Content-Type': "application/json; charset=UTF-8",
        'Authorization': 'Basic b3JnYW5vbnBybzpPcmdhbm9ucHIw' // Basic auth for popup organonpro website
       },
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          setIsContentLoaded(true);
          setMyOrderData(data.results.items);

          if (data.results.items.length === 0) {
            setErrorsStatusUI(prevState => ({ ...prevState, orderEmpty: true }));
          } else {
            localStorage.setItem("sampleItems", JSON.stringify(data.results.items));
          }
        } else if (["404", "500", "400"].includes(data.status) || data.error === "Invalid Client") {
          setErrorsStatusUI(prevState => ({ ...prevState, badRequest: true }));
          setIsContentLoaded(true);
        }
      })
      .catch(() => {
        setErrorsStatusUI(prevState => ({ ...prevState, criticalErrorAPIend: true }));
        setIsContentLoaded(true);
      });
  }, []);

  /**
   * This effect runs when viewOrderMaterialsDetails changes.
   * It initializes and shows the Bootstrap modal if viewOrderMaterialsDetails is not null.
   */
  useEffect(() => {
    if (viewOrderMaterialsDetails) {
      const modalElement = document.getElementById('vieworderpopup');
      const modal = new bootstrap.Modal(modalElement);
      setModalInstance(modal);
      modal.show();
    }
  }, [viewOrderMaterialsDetails]);

  /**
   * Function to view order item details.
   * It retrieves the order details from localStorage and sets the state to display them in a modal.
   * @param {string} orderNo - The order number to view details for.
   */
  const viewOrderItem = (orderNo) => {
    let sampleItems = JSON.parse(localStorage.getItem('sampleItems'));
    let viewResources = sampleItems?.filter(item => item.orderNo === orderNo);
    setViewOrderMaterialsDetails(viewResources?.length > 0 ? viewResources[0] : null);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const hideModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    if (modalInstance) {
      modalInstance.hide();
    }
    setViewOrderMaterialsDetails(null)
  };

  const {
    lang_si_shipping_information,
    template_directory_uri,
    lang_my_order,
    lang_order_id,
    lang_user_name,
    lang_order_user_email,
    lang_number_of_items_order,
    lang_my_order_is_empty_msg,
    lang_my_order_something_went_wrong_msg,
    lang_my_order_critical_error_api_msg,
    lang_created_order,
    lang_view_order,
    lang_my_order_material_variant,
    lang_my_order_material_size,
  } = window.ordering_cart_script_checkout;

  return (
    <div className="myordermodule">
      {!isContentLoaded && (
        <div className="product-container container text-center">
          <img src={`${template_directory_uri}/assets/images/spinner.gif`} alt="Loading spinner" />
        </div>
      )}
      <div className="myOrderContainer container" style={{ display: isContentLoaded ? 'block' : 'none' }}>
        <p className="myordertitle">{lang_my_order}</p>
        {errorsStatusUI.orderEmpty && <div className="alert alert-info">{lang_my_order_is_empty_msg}</div>}
        {errorsStatusUI.badRequest && <div className="alert alert-warning">{lang_my_order_something_went_wrong_msg}</div>}
        {errorsStatusUI.criticalErrorAPIend && <div className="alert alert-danger">{lang_my_order_critical_error_api_msg}</div>}
        {myOrderData.length > 0 && myOrderData.map(order => (
          <div key={order.orderNo} className="myorderCards">
            <div className="myorder">
              <div className="row content">
                <div className="col-sm-4">
                  <div className="order-detailes">
                    <div className="ordercreatedid"><a href="#">{lang_order_id}: {order.orderNo}</a></div>
                    <div className="order-username">{lang_user_name}: {order.firstName} {order.lastName}</div>
                    <div className="order-email">{lang_order_user_email}: {order.email}</div>
                    <div className="order-items">{lang_number_of_items_order}: {order.no_of_products}</div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="order-detailes">
                    <div className="ordercreatedid">{lang_si_shipping_information}:</div>
                    <div className="order-items">{order.address}</div>
                    <div className="order-items">{order.appartment}</div>
                    <div className="order-items">{order.suite}, {order.city}, {order.province}</div>
                    <div className="order-items">{order.postcode}</div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="ordercreated-date">
                    <div className="greenDot _5cm2Hi"></div><span>{lang_created_order} {order.order_date_time}</span>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="ordercreated-vieworder">
                    <div className='viewmyorder'>
                      <button className="btn btn-theme nav-link" type='button' onClick={() => viewOrderItem(order.orderNo)}>
                        {lang_view_order}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div class="modal fade" tabindex="-1" id="vieworderpopup">
        <div class="modal-dialog modal-dialog-centered  modal-lg vieworderitemspopup">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close btn-close" data-bs-dismiss="modal" onClick={hideModal} id="viewmyordeclose"></button>
            </div>
            <div className='modal-body'>
              <div className='viewmyorder-row'>
                {viewOrderMaterialsDetails &&
                  <div className='viewmyorder'>
                    <div className='row content'>
                      <div class="col-sm-6">
                        <div class="order-detailes">
                          <div class="ordercreatedid"><a href="#">{lang_order_id}: {viewOrderMaterialsDetails.orderNo}</a></div>
                          <div class="order-username">{lang_user_name}: {viewOrderMaterialsDetails.firstName} {viewOrderMaterialsDetails.lastName} </div>
                          <div class="order-email">{lang_order_user_email}: {viewOrderMaterialsDetails.email}</div>
                          <div class="order-items">{lang_number_of_items_order}: {viewOrderMaterialsDetails.no_of_products}</div>
                        </div>
                        <div class="vieworder-shippingdetailes">
                          <div class="shipping-detailes">
                            <div class="viewordershipping">{lang_si_shipping_information}:</div>
                            <div class="vieworder-shipitem">{viewOrderMaterialsDetails.address}</div>
                            <div class="vieworder-shipitem">{viewOrderMaterialsDetails.appartment}</div>
                            {
                              viewOrderMaterialsDetails.suite && viewOrderMaterialsDetails.city && viewOrderMaterialsDetails.province && <div class="vieworder-shipitem">{viewOrderMaterialsDetails.suite}, {viewOrderMaterialsDetails.city}, {viewOrderMaterialsDetails.province}</div>
                            }
                            {
                              viewOrderMaterialsDetails.suite && !viewOrderMaterialsDetails.city && !viewOrderMaterialsDetails.province && <div class="vieworder-shipitem">{viewOrderMaterialsDetails.suite}</div>
                            }
                            {
                              !viewOrderMaterialsDetails.suite && viewOrderMaterialsDetails.city && !viewOrderMaterialsDetails.province && <div class="vieworder-shipitem">{viewOrderMaterialsDetails.city}</div>
                            }
                            {!viewOrderMaterialsDetails.suite && !viewOrderMaterialsDetails.city && viewOrderMaterialsDetails.province && <div class="vieworder-shipitem">{viewOrderMaterialsDetails.province}</div>}
                            <div class="vieworder-shipitem">{viewOrderMaterialsDetails.postcode}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 view-order-section">
                        {
                          viewOrderMaterialsDetails.orderItems.length > 0 && <div>
                            {
                              viewOrderMaterialsDetails?.orderItems.map((ordermaterialsItem, index) => {
                                return <div key={index} class="myorderCards">
                                  <div class="view-order-materials">
                                    <h1 class="vieworder-materialtitle">{ordermaterialsItem.material_title}</h1>
                                    {ordermaterialsItem.order_variant && ordermaterialsItem.order_size && <p class="viewordervarient">{lang_my_order_material_variant} - {ordermaterialsItem.order_variant}, {lang_my_order_material_size} - {ordermaterialsItem.order_size}</p>}
                                    {ordermaterialsItem.order_variant && !ordermaterialsItem.order_size && <p class="viewordervarient">{lang_my_order_material_variant} - {ordermaterialsItem.order_variant}</p>}
                                    {!ordermaterialsItem.order_variant && ordermaterialsItem.order_size && <p class="viewordervarient">{lang_my_order_material_size} - {ordermaterialsItem.order_size}</p>}
                                    <p class="vieworderItemQuantity vieworderquantity">x{ordermaterialsItem.order_quantity}</p>
                                  </div>
                                </div>
                              })
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganonOrderingCartOrderConfirmation;